import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-checkbox',
  standalone: false,
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss',
})
export class CheckboxComponent {
  @Input() size: number = 25;
  @Input() color: string = '#555';
  @Input() checked: boolean = false;
  @Input() readOnly: boolean = false;
  @Output() checkedChange = new EventEmitter<boolean>();

  onClick(): void {
    if (!this.readOnly) {
      this.checked = !this.checked;
      this.checkedChange.emit(this.checked);
    }
  }
}
